var DefaultQueryParams;
(function (DefaultQueryParams) {
    DefaultQueryParams["Token"] = "token";
    DefaultQueryParams["UserId"] = "userid";
    DefaultQueryParams["GameId"] = "gameid";
    DefaultQueryParams["GameTypeId"] = "gametypeid";
    DefaultQueryParams["ExitUrl"] = "exiturl";
    DefaultQueryParams["PartnerId"] = "partnerid";
    DefaultQueryParams["BetId"] = "betId";
    DefaultQueryParams["Currency"] = "currency";
    DefaultQueryParams["PlayerExternalId"] = "playerexternalid";
    DefaultQueryParams["PlayerId"] = "playerexternalid";
    DefaultQueryParams["Mode"] = "mode";
    DefaultQueryParams["CurrencySymbol"] = "currencysymbol";
    DefaultQueryParams["RealModeSwitcher"] = "realmodeswitcher";
    DefaultQueryParams["Theme"] = "theme";
    DefaultQueryParams["Culture"] = "culture";
    DefaultQueryParams["IsCashDesk"] = "iscashdesk";
    DefaultQueryParams["TournamentId"] = "tournamentid";
    DefaultQueryParams["HidePlayerId"] = "hideplayerid";
    DefaultQueryParams["CheckBalanceOnBet"] = "checkbalanceonbet";
})(DefaultQueryParams || (DefaultQueryParams = {}));

export { DefaultQueryParams };
